export {requestScrollUnlock as default} from './scroll-lock/scroll-lock';
